import React from 'react';
import { FaLinkedin, FaInstagram, FaYoutube, FaGithub, FaEnvelope, FaRegEnvelope } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';

export default function Icon({ name, size = 20 }) {
    if (!name) return null;
    const key = String(name).toLowerCase();
    if (key.includes('linkedin')) return <FaLinkedin size={size} />;
    if (key.includes('instagram')) return <FaInstagram size={size} />;
    if (key.includes('github')) return <FaGithub size={size} />;
    if (key.includes('youtube')) return <FaYoutube size={size} />;
    if (key.includes('tiktok')) return <FaTiktok size={size} />;
    // Soporte para direcciones de correo (mail, email, correo, gmail, outlook, hotmail)
    if (
        key.includes('mail') ||
        key.includes('email') ||
        key.includes('correo') ||
        key.includes('gmail') ||
        key.includes('outlook') ||
        key.includes('hotmail')
    ) return <FaRegEnvelope size={size} />;
    return null;
}
